// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { FileDescriptorReadUserSuppliedMeta } from "./FileDescriptorReadUserSuppliedMeta";
import {
  FileDescriptorReadUserSuppliedMetaFromJSON,
  FileDescriptorReadUserSuppliedMetaFromJSONTyped,
  FileDescriptorReadUserSuppliedMetaToJSON,
  FileDescriptorReadUserSuppliedMetaToJSONTyped,
} from "./FileDescriptorReadUserSuppliedMeta";
import type { NormalisedLayer } from "./NormalisedLayer";
import {
  NormalisedLayerFromJSON,
  NormalisedLayerFromJSONTyped,
  NormalisedLayerToJSON,
  NormalisedLayerToJSONTyped,
} from "./NormalisedLayer";
import type { State } from "./State";
import { StateFromJSON, StateFromJSONTyped, StateToJSON, StateToJSONTyped } from "./State";
import type { FileDescriptorReadMeta } from "./FileDescriptorReadMeta";
import {
  FileDescriptorReadMetaFromJSON,
  FileDescriptorReadMetaFromJSONTyped,
  FileDescriptorReadMetaToJSON,
  FileDescriptorReadMetaToJSONTyped,
} from "./FileDescriptorReadMeta";
import type { Link } from "./Link";
import { LinkFromJSON, LinkFromJSONTyped, LinkToJSON, LinkToJSONTyped } from "./Link";

/**
 *
 * @export
 * @interface FileDescriptorRead
 */
export interface FileDescriptorRead {
  /**
   *
   */
  id: string;
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  updatedAt: Date;
  /**
   *
   */
  tenant?: string;
  /**
   *
   */
  status?: State;
  /**
   *
   */
  dataType?: string | null;
  /**
   *
   */
  meta?: FileDescriptorReadMeta | null;
  /**
   *
   */
  userSuppliedMeta?: FileDescriptorReadUserSuppliedMeta;
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  description?: string;
  /**
   *
   */
  links: Array<Link>;
  /**
   *
   */
  readonly views: Array<string>;
  /**
   *
   */
  readonly layers: Array<NormalisedLayer>;
  /**
   *
   */
  readonly allowsMapLayer: boolean;
}

/**
 * Check if a given object implements the FileDescriptorRead interface.
 */
export function instanceOfFileDescriptorRead(value: object): value is FileDescriptorRead {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (
    (!("updatedAt" in (value as Record<string, any>)) &&
      !("updated_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["updatedAt"] === undefined &&
      (value as Record<string, any>)["updated_at"] === undefined)
  )
    return false;
  if (
    (!("projectId" in (value as Record<string, any>)) &&
      !("project_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["projectId"] === undefined &&
      (value as Record<string, any>)["project_id"] === undefined)
  )
    return false;
  if (!("links" in value) || value["links"] === undefined) return false;
  if (!("views" in value) || value["views"] === undefined) return false;
  if (!("layers" in value) || value["layers"] === undefined) return false;
  if (
    (!("allowsMapLayer" in (value as Record<string, any>)) &&
      !("allows_map_layer" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["allowsMapLayer"] === undefined &&
      (value as Record<string, any>)["allows_map_layer"] === undefined)
  )
    return false;
  return true;
}

export function FileDescriptorReadFromJSON(json: any): FileDescriptorRead {
  return FileDescriptorReadFromJSONTyped(json, false);
}

export function FileDescriptorReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FileDescriptorRead {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    updatedAt: json["updated_at"] == null ? json["updated_at"] : parseDateTime(json["updated_at"]),
    tenant: json["tenant"] == null ? undefined : json["tenant"],
    status: json["status"] == null ? undefined : StateFromJSON(json["status"]),
    dataType:
      json["data_type"] === undefined
        ? undefined
        : json["data_type"] === null
        ? null
        : json["data_type"],
    meta:
      json["meta"] === undefined
        ? undefined
        : json["meta"] === null
        ? null
        : FileDescriptorReadMetaFromJSON(json["meta"]),
    userSuppliedMeta:
      json["user_supplied_meta"] == null
        ? undefined
        : FileDescriptorReadUserSuppliedMetaFromJSON(json["user_supplied_meta"]),
    projectId: json["project_id"],
    description: json["description"] == null ? undefined : json["description"],
    links: (json["links"] as Array<any>).map(LinkFromJSON),
    views: json["views"],
    layers: (json["layers"] as Array<any>).map(NormalisedLayerFromJSON),
    allowsMapLayer: json["allows_map_layer"],
  };
}

export function FileDescriptorReadToJSON(json: any): FileDescriptorRead {
  return FileDescriptorReadToJSONTyped(json, false);
}

export function FileDescriptorReadToJSONTyped(
  value?: Omit<FileDescriptorRead, "views" | "layers" | "allowsMapLayer"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    updated_at:
      value["updatedAt"] == null ? value["updatedAt"] : serializeDateTime(value["updatedAt"]),
    tenant: value["tenant"],
    status: StateToJSON(value["status"]),
    data_type: value["dataType"],
    meta: FileDescriptorReadMetaToJSON(value["meta"]),
    user_supplied_meta: FileDescriptorReadUserSuppliedMetaToJSON(value["userSuppliedMeta"]),
    project_id: value["projectId"],
    description: value["description"],
    links: (value["links"] as Array<any>).map(LinkToJSON),
  };
}
